import React from 'react';
import ReactDOM from 'react-dom';
import { Form, InputNumber } from 'antd';
const FormItem = Form.Item;
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm';
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun";

class SgiFormInputNumber extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        //初始化state属性
        this.initState();
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {当前工作区} ws
     * @param {make类型} type
     */
    inputNumber_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //转换form公共属性
        AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定值
        bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
    }


    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    AddInputAttribute(moduleDesc, formItem, inputprops) {
        var selectType = moduleDesc.selectType;//是否符号 01金钱 02百分比
        if (selectType == "00") {
            inputprops.formatter = (value => value);
            inputprops.parser = (value => value);
        }

        if (selectType == "01") {
            inputprops.formatter = (value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
            inputprops.parser = (value => value.replace(/\$\s?|(,*)/g, ''))
        }
        if (selectType == "02") {
            inputprops.formatter = (value => `${value}%`);
            inputprops.parser = (value => value.replace('%', ''))
        }

        var maxV = moduleDesc.maxV; //输入最大值
        if (maxV || maxV === 0) inputprops.max = maxV;

        var minV = moduleDesc.minV; //输入最小值
        if (minV || minV === 0) inputprops.min = minV;

        var step = moduleDesc.step; //微调的数字间距，value 的精度由 step 的小数位数决定。
        if (step || step === 0) inputprops.step = step;

        var dcmDgt = moduleDesc.dcmDgt; // 小数位>step
        if (dcmDgt || dcmDgt === 0) inputprops.precision = dcmDgt;

        var intDgt = moduleDesc.intDgt; //整数位

        // 是否隐藏微调，控件本身微调就是隐藏的，鼠标悬浮时微调显示
        var isHdnTg = moduleDesc.isHdnTg;

        //csstyle 样式文件?这个我还不知道怎么用
        var csstyle = moduleDesc.csstyle;
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.inputNumber_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        let addonAfter = undefined;
        if (this.state.inputprops.addonAfter) {
            this.state.inputprops.style.width = '80%';
            addonAfter = <div style={{ display: 'block', height: '32px' }}>
                <span className={"ant-input-group-addon"}>
                    {this.state.inputprops.addonAfter}</span></div>
        }

        // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
        const { _inputProps, _formItemProps } = this.getReviseProps();
        const { isLabel } = _inputProps;

        // 渲染前通用处理，如自定义样式等
        this.renderBeforeReturn();

        let ctl = (isLabel)
            ? <span {...this.state.inputprops} {..._inputProps}>{this.state.inputprops.value}</span>
            : <InputNumber {...this.state.inputprops} {..._inputProps}></InputNumber>
        addonAfter;

        return this.state.noFI ? ctl : <FormItem {...this.state.formItemProps} {..._formItemProps}>{ctl}</FormItem >;
    }
}

//给类添加公共方法
Object.assign(SgiFormInputNumber.prototype, sgiFormCtlBaseFun);

export { SgiFormInputNumber };
export default SgiFormInputNumber;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiFormInputNumber.js